import { useNavigate } from 'react-router-dom'

import { TimeoffPoliciesMoveEmployeeModalPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import MoveEmployeeModal from 'modules/timeoff/components/TimeoffPolicy/MoveEmployee'

const MoveEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id, employeeId } = useStrictParams<'id' | 'employeeId'>()
  const timeoffPolicyId = String(id)

  const { data, loading } = useQuery(TimeoffPoliciesMoveEmployeeModalPageDocument, {
    variables: {
      timeoffPolicyId,
      employeeId: String(employeeId),
    },
  })

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.id.employees.fullPath({ id }))
  }

  return <MoveEmployeeModal loading={loading} data={data} onClose={onClose} />
}

export default MoveEmployeeModalPage
